import { flattenDeep } from 'lodash';
import { Iterable } from 'immutable';

export const customers = state => state.getIn(['customers', 'entities']);
export const customerById = (state, id) => state.getIn(['customers', 'entities', String(id)]);
export const customersByIds = (state, ids) => ids.map(id => customerById(state, id));

export function customerHierarchyIds(state, maybeImmutableIds) {
  const ids = Iterable.isIterable(maybeImmutableIds) ? maybeImmutableIds.toJS() : maybeImmutableIds;

  const childIds = flattenDeep(
    flattenDeep(ids
      .map(id => customerById(state, id))
      .map(customer => (customer.children ? customer.children.toJS() : []))) // flatten ends.
      .map(id => customerHierarchyIds(state, [id])),
  );

  return [
    ...ids,
    ...childIds,
  ];
}

export const customerHierarchyIdsById = (state, customerId) => {
  const customer = customerById(state, customerId);
  if (!customer || !customer.hierarchy) {
    return undefined;
  }

  return customerHierarchyIds(state, customer.hierarchy);
};
